import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './views.component.html',
  styleUrls: ['./views.component.css'],
})
export class ViewsComponent implements OnInit {
  loginDisplay = false;

  constructor(
  ) { }

  ngOnInit(): void {

  }

}
